webpackJsonp([8228658491823],{

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SoundCloud = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SoundCloud = exports.SoundCloud = function (_React$PureComponent) {
		_inherits(SoundCloud, _React$PureComponent);
	
		// Can't use async => because of a Babel bug.
		function SoundCloud(props, context) {
			_classCallCheck(this, SoundCloud);
	
			var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));
	
			_this.state = {
				iframe: null
			};
	
			_this.fetchSoundcloudWidget = function () {
				var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
					var formData, result, iframe;
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									this.setState({ iframe: null });
	
									_context.prev = 1;
									formData = new FormData();
	
									formData.append('format', 'json');
									formData.append('height', 91);
									formData.append('show_comments', false);
									formData.append('url', url);
	
									_context.next = 9;
									return fetch('https://soundcloud.com/oembed', {
										body: formData,
										method: 'POST'
									}).then(function (response) {
										return response.json();
									});
	
								case 9:
									result = _context.sent;
	
	
									if (result && result.html) {
										// They default to the Visual player which we don't want.
										iframe = result.html.replace('visual=true&', '').replace('height="400"', 'height="166"');
	
	
										this.setState({ iframe: iframe });
									}
									_context.next = 17;
									break;
	
								case 13:
									_context.prev = 13;
									_context.t0 = _context['catch'](1);
	
									this.setState({ error: _context.t0 });
									console.error(_context.t0);
	
								case 17:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this, [[1, 13]]);
				}));
	
				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}();
	
			_this.componentWillReceiveProps = function (nextProps) {
				_this.fetchSoundcloudWidget(nextProps.url);
			};
	
			_this.componentDidMount = function () {
				_this.fetchSoundcloudWidget(_this.props.url);
			};
	
			_this.fetchSoundcloudWidget = _this.fetchSoundcloudWidget.bind(_this);
			return _this;
		}
	
		SoundCloud.prototype.render = function render() {
			var _state = this.state,
			    error = _state.error,
			    iframe = _state.iframe;
	
	
			if (error) {
				return _react2.default.createElement(
					'p',
					null,
					'Error'
				);
			}
			if (!iframe) {
				return _react2.default.createElement(
					'p',
					null,
					'Loading...'
				);
			}
	
			return _react2.default.createElement('div', {
				dangerouslySetInnerHTML: {
					__html: this.state.iframe
				}
			});
		};
	
		return SoundCloud;
	}(_react2.default.PureComponent);
	
	SoundCloud.propTypes = {
		url: _propTypes2.default.string.isRequired
	};

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(474);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageHeaderInnerWrapperStyle = exports.pageHeaderStyle = exports.metaBottomStyle = exports.bookmarkMobileButtonStyle = exports.detailWrapperStyle = exports.mobileShareStyle = exports.bookmarkButtonStyle = exports.metaAudiencesStyle = exports.subTitleStyle = exports.titleStyle = exports.thumbnailStyle = exports.ctaStyle = exports.bodyStyle = exports.innerWrapperStyle = undefined;
	
	var _css, _css2, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		position: 'relative'
	});
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlockRichFormat, /*#__PURE__*/(0, _emotion.css)({
		h1: (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
			margin: '0 0 36px 0'
		}))
	}));
	
	var ctaStyle = /*#__PURE__*/exports.ctaStyle = (0, _emotion.css)({
		marginTop: '60px',
		'& > *': {
			marginTop: '30px'
		}
	});
	
	var thumbnailStyle = /*#__PURE__*/exports.thumbnailStyle = (0, _emotion.css)((_css = {
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '6px',
		marginBottom: '20px',
	
		'& img': {
			width: '100%',
			maxWidth: '100%'
		}
	
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: '800px',
		margin: '0 0 24px 0',
		color: '#fff'
	}));
	
	var subTitleStyle = exports.subTitleStyle = (0, _emotion.cx)(_globalStyles.headingMediumLight, /*#__PURE__*/(0, _emotion.css)({
		paddingBottom: '15px'
	}));
	
	var metaAudiencesStyle = /*#__PURE__*/exports.metaAudiencesStyle = (0, _emotion.css)({
		'& svg:not(:last-child)': {
			marginRight: '6px'
		},
		zIndex: '2',
		marginBottom: '11px'
	});
	
	var bookmarkButtonStyle = /*#__PURE__*/exports.bookmarkButtonStyle = (0, _emotion.css)({
		background: 'none',
		border: 'none',
		padding: 0,
		display: 'inline-block',
		marginBottom: '35px'
	});
	
	var mobileShareStyle = /*#__PURE__*/exports.mobileShareStyle = (0, _emotion.css)((_css2 = {
		display: 'none'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		position: 'fixed',
		left: '0',
		bottom: '0',
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '5px 10px',
		background: '#F6F6F6',
		borderTop: '1px solid ' + _globalStyles.lightGrey
	}, _css2));
	
	var detailWrapperStyle = exports.detailWrapperStyle = (0, _emotion.cx)(_globalStyles.detailSideBarLayout.wrapper, /*#__PURE__*/(0, _emotion.css)({
		paddingBottom: '80px'
	}));
	
	var bookmarkMobileButtonStyle = /*#__PURE__*/exports.bookmarkMobileButtonStyle = (0, _emotion.css)({
		border: 'none',
		padding: '0'
	});
	
	var metaBottomStyle = /*#__PURE__*/exports.metaBottomStyle = (0, _emotion.css)({
		'& span': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css3 = {
			color: '#fff'
		}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
			fontSize: '12px'
		}, _css3['&:not(:last-child)'] = {
			marginRight: '40px',
			position: 'relative',
			'&:after': {
				content: "'•'",
				display: 'block',
				position: 'absolute',
				transform: 'translate(-50%, -50%)',
				left: 'calc(100% + 20px)',
				top: '50%'
			}
		}, _css3)))
	});
	
	var pageHeaderStyle = exports.pageHeaderStyle = function pageHeaderStyle(background) {
		return (/*#__PURE__*/(0, _emotion.css)({
				minHeight: '270px',
				background: 'transparent url(' + background + ') no-repeat center center',
				backgroundSize: 'cover',
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
	
				'&:after': {
					position: 'absolute',
					top: '0',
					left: '0',
					opacity: '0.6',
					width: '100%',
					height: '100%',
					display: 'block',
					content: '" "',
					background: '#000',
					borderRadius: '6px'
				}
			})
		);
	};
	
	var pageHeaderInnerWrapperStyle = exports.pageHeaderInnerWrapperStyle = (0, _emotion.cx)(innerWrapperStyle, /*#__PURE__*/(0, _emotion.css)({
		position: 'relative',
		zIndex: '1',
		padding: '0 37px'
	}));

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _headerManager = __webpack_require__(31);
	
	var _navManager = __webpack_require__(22);
	
	var _fullWidthCTA = __webpack_require__(170);
	
	var _audienceManager = __webpack_require__(121);
	
	var _soundCloud = __webpack_require__(475);
	
	var _socialIcons = __webpack_require__(172);
	
	var _audienceIcon = __webpack_require__(105);
	
	var _audienceIcon2 = _interopRequireDefault(_audienceIcon);
	
	var _bookmarkIcon = __webpack_require__(217);
	
	var _bookmarkIcon2 = _interopRequireDefault(_bookmarkIcon);
	
	var _detail = __webpack_require__(479);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var audienceList = ['for-healthcare-professionals', 'for-myself', 'family-and-carers'];
	
	// Gatsby requires a specific export format on Templates.
	
	var PodcastDetail = function (_React$PureComponent) {
	  _inherits(PodcastDetail, _React$PureComponent);
	
	  function PodcastDetail() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PodcastDetail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.componentDidMount = function () {
	      _headerManager.HeaderManager.headerProperties = {};
	    }, _this.convertVimeoURL = function (vimeo_url) {
	      var replacement = '//player.vimeo.com/video/$1';
	      return vimeo_url.replace(/(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g, replacement);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PodcastDetail.prototype.render = function render() {
	    var _this2 = this;
	
	    var node = this.props.data.podcast.edges[0].node;
	
	    var audiences = (0, _audienceManager.fullAudiences)(node.audiences);
	
	    var hasVideoAttachment = node.attachments && node.attachments.find(function (attachment) {
	      return attachment.vimeo_url;
	    });
	    var bookmarkableContent = {
	      to: (0, _navManager.idToLink)(node.id),
	      audiences: audiences,
	      title: node.title,
	      body: node.extract,
	      date: node.date,
	      hasVideo: hasVideoAttachment,
	      background: node.fields && node.fields.thumbnail_image && node.fields.thumbnail_image.childImageSharp.resize.src
	    };
	
	    return _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        { title: node.title },
	        _react2.default.createElement('meta', { name: 'description', content: node.extract }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: node.title }),
	        _react2.default.createElement('meta', { property: 'og:description', content: node.extract }),
	        node.fields && node.fields.thumbnail_image && node.fields.thumbnail_image.childImageSharp.resize.src && _react2.default.createElement('meta', { property: 'og:image', content: 'https://insideoutinstitute.org.au' + node.fields.thumbnail_image.childImageSharp.resize.src })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _detail.innerWrapperStyle },
	        _react2.default.createElement(
	          'div',
	          { className: _detail.detailWrapperStyle },
	          _react2.default.createElement(
	            'div',
	            { className: _globalStyles.detailSideBarLayout.leftSide },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _globalStyles.contentSection)('#fff') },
	              !hasVideoAttachment && node.fields && _react2.default.createElement(
	                'div',
	                { className: _detail.thumbnailStyle },
	                _react2.default.createElement('img', {
	                  src: node.fields.thumbnail_image.childImageSharp.resize.src,
	                  alt: ''
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _detail.metaAudiencesStyle },
	                audiences.map(function (audience) {
	                  return _react2.default.createElement(_audienceIcon2.default, { key: audience.id, audience: audience, size: 12 });
	                })
	              ),
	              _react2.default.createElement(
	                'h1',
	                { className: _detail.titleStyle },
	                node.title
	              ),
	              _react2.default.createElement('div', {
	                className: _detail.bodyStyle,
	                dangerouslySetInnerHTML: { __html: node.body }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _detail.ctaStyle },
	                node.attachments && node.attachments.map(function (attachment, index) {
	                  var href = attachment.file || attachment.url;
	                  if (attachment.soundcloud_url) {
	                    return _react2.default.createElement(_soundCloud.SoundCloud, { key: index, url: attachment.soundcloud_url });
	                  } else if (attachment.vimeo_url) {
	                    return _react2.default.createElement('iframe', {
	                      key: index,
	                      src: _this2.convertVimeoURL(attachment.vimeo_url),
	                      width: '100%',
	                      frameBorder: '0',
	                      webkitallowfullscreen: 'true',
	                      mozallowfullscreen: 'true',
	                      allowFullScreen: 'true' });
	                  } else if (href) {
	                    return _react2.default.createElement(
	                      _fullWidthCTA.FullWidthCTA,
	                      { key: index, link: { href: href } },
	                      attachment.link_text || 'Read Full Article'
	                    );
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _detail.mobileShareStyle },
	            _react2.default.createElement(_socialIcons.SocialIcons, _extends({ inline: true, mode: 'share' }, node)),
	            _react2.default.createElement(
	              'div',
	              { className: _detail.bookmarkMobileButtonStyle, 'data-bookmark': 'true' },
	              _react2.default.createElement(_bookmarkIcon2.default, { width: 27, bookmarkableContent: bookmarkableContent, bookmarkType: 'podcast' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _globalStyles.detailSideBarLayout.rightSide },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _globalStyles.contentSection)('#fff') },
	              _react2.default.createElement(
	                'div',
	                { className: _detail.bookmarkButtonStyle, 'data-bookmark': 'true' },
	                _react2.default.createElement(_bookmarkIcon2.default, { width: 32, bookmarkableContent: bookmarkableContent, bookmarkType: 'podcast' })
	              ),
	              _react2.default.createElement(_socialIcons.SocialIcons, _extends({ mode: 'share' }, node))
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PodcastDetail;
	}(_react2.default.PureComponent);
	
	PodcastDetail.propTypes = {
	  data: _propTypes2.default.shape({
	    podcast: _propTypes2.default.shape({
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape({
	          id: _propTypes2.default.string.isRequired,
	          audiences: _propTypes2.default.arrayOf(_propTypes2.default.string),
	          title: _propTypes2.default.string.isRequired,
	          date: _propTypes2.default.string.isRequired,
	          extract: _propTypes2.default.string,
	          body: _propTypes2.default.string.isRequired,
	          fields: _propTypes2.default.shape({
	            thumbnail_image: _propTypes2.default.shape({
	              childImageSharp: _propTypes2.default.shape({
	                resize: _propTypes2.default.shape({
	                  src: _propTypes2.default.string.isRequired
	                })
	              })
	            })
	          }),
	          attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	            file: _propTypes2.default.string,
	            url: _propTypes2.default.string,
	            link_text: _propTypes2.default.string,
	            vimeo_url: _propTypes2.default.string,
	            soundcloud_url: _propTypes2.default.string
	          }))
	        })
	      }))
	    })
	  })
	};
	exports.default = PodcastDetail;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-and-podcast-podcast-detail-index-js-3090c3edabacdfe4e9a2.js